
  import resetPassword from '~/mixins/common/pages/reset-password'
  export default {
    mixins: [resetPassword],
    middleware: 'checkAuth',
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      modal: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    }
  }
